/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmVectorStoresGetFileBatch } from "../../funcs/llmVectorStoresGetFileBatch.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetVectorStoreFileBatchRequest$inboundSchema,
};

export const tool$llmVectorStoresGetFileBatch: ToolDefinition<typeof args> = {
  name: "llm-vector-stores-get-file-batch",
  description: `Retrieve file batch status

Retrieves the status of a specific file batch operation within a vector store.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmVectorStoresGetFileBatch(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
